import {getMethod, postMethod, putMethod} from '~/api'

async function post(body) {
    return await postMethod('/api/reviews', body)
}

async function get(request) {
    return await getMethod('/api/reviews', request)
}

async function put(id, request) {
    return await putMethod(`/api/reviews/${id}`, request)
}

export {post, get, put}
